import { render, staticRenderFns } from "./ProjectVersion.vue?vue&type=template&id=43b21d39&scoped=true&"
import script from "./ProjectVersion.vue?vue&type=script&lang=js&"
export * from "./ProjectVersion.vue?vue&type=script&lang=js&"
import style0 from "./ProjectVersion.vue?vue&type=style&index=0&id=43b21d39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b21d39",
  null
  
)

export default component.exports